export default "/assets/images/mila-valentine.35b37c5dbeea6fac.png";